/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'config': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M512 960L123.84 736V288L512 64l388.16 224v448zM249.12 663.84L512 816l262.88-151.52v-304L512 208 249.12 360.16z"/><path pid="1" d="M386.72 512A125.28 125.28 0 10512 386.56 125.12 125.12 0 00386.72 512z"/>'
  }
})
